import React from 'react';

const HiddenFeature = () => {
  return <h2 style={{ textAlign: 'center' }}>Your app doesn't have this feature yet</h2>;
};

export default HiddenFeature;
